import pad from './pad';
export default ((value, sign) => {
    const [year, month] = value.split('-').map(Number);
    if (month + sign === 0) {
        return `${year - 1}-12`;
    }
    else if (month + sign === 13) {
        return `${year + 1}-01`;
    }
    else {
        return `${year}-${pad(month + sign)}`;
    }
});
